const dayInMs = 24 * 60 * 60 * 1000;
export function addDaysToTimestampInMs(timestamp, numOfDays) {
    const daysInMs = numOfDays * dayInMs;
    return timestamp + daysInMs;
}
//# sourceMappingURL=dateUtils.js.map